<template>
	<form id="form" name="student">
		<section class="columns">
			<div class="column">
				<div class="card">
					<header class="card-header">
						<p class="card-header-title">Actieve Schooljaar</p>
					</header>
					<header class="card-header" style="background-color:#eeeeee;padding: 12px;">
						<nav class="level">
							<div class="level-left">
								<div class="level-item">
									<b-field>
										<a class="button is-primary" @click="new_schoolyear()">
											<b-icon icon="plus-circle-outline"></b-icon>
											<span>Nieuw Schooljaar</span>
										</a>
									</b-field>
								</div>
							</div>
						</nav>
					</header>
					<div style="padding:5px;">
						<b-table
							:data="schoolyears"
							:bordered="false"
							:narrowed="true"
							:striped="true"
							:loading="loading"
							:paginated="isPaginated"
							:per-page="perPage"
							:current-page.sync="currentPage"
							:pagination-simple="isPaginationSimple"
							:default-sort-direction="defaultSortDirection"
						>
							<template slot-scope="props">
								<b-table-column>
									<a class="button icon is-text" @click="handleClick(props.row.id)">
										<b-icon icon="lead-pencil"></b-icon>
									</a>
								</b-table-column>
								<b-table-column label="Schooljaar" field="name">{{ props.row.name }}</b-table-column>
								<b-table-column label="Opmerking" field="name">{{ props.row.description }}</b-table-column>
								<b-table-column label="Aktief" field="active">{{ props.row.active ? " Ja" : "Nee" }}</b-table-column>
								<b-table-column label="Beroep" field="appeal">{{ props.row.appeal ? "Ja" : "Nee"}}</b-table-column>
							</template>

							<template slot="empty">
								<section class="section">
									<div class="content has-text-grey has-text-centered">
										<p>
											<b-icon icon="frown"></b-icon>
										</p>
										<p>Nothing here.</p>
									</div>
								</section>
							</template>
						</b-table>
					</div>
				</div>
			</div>
		</section>
	</form>
</template>
<script>
import Axios from "axios";
import Cookies from "js-cookie";

import { API_ROOT } from "../config";

var instance = Axios.create({
	baseURL: API_ROOT,
	timeout: 60000
});

export default {
	data() {
		return {
			schoolyears: [],
			isEmpty: false,
			isPaginated: false,
			isPaginationSimple: false,
			defaultSortDirection: "asc",
			currentPage: 1,
			perPage: 12
		};
	},
	created: function() {
		this.getSchoolyears();
	},
	watch: {},
	methods: {
		getSchoolyears: function() {
			var self = this;
			self.loading = true;
			instance.get("/schoolyear").then(function(response) {
				console.log("Get schools...");
				console.log(response.data.data);

				self.schoolyears = response.data.data;
				self.loading = false;
			});
		},
		handleClick(id) {
			this.$router.push({
				path: "/okrconfig/update/" + id
			});
		},
		new_schoolyear: function() {
			this.$router.push({
				path: "/okrconfig/new"
			});
		}
	}
};
</script>
